// Real MLB team brand color pairs, keyed by full team name as returned
// by the vendor (`/standings`, `/teams` — e.g. "Texas Rangers"). Used
// to render two-tone diagonal-split circle swatches in place of team
// logos (no crest imagery anywhere in the app — licensing risk).
export const MLB_TEAM_COLORS = {
    // AL East
    "Baltimore Orioles": ["#DF4601", "#000000"],
    "Boston Red Sox": ["#BD3039", "#0C2340"],
    "New York Yankees": ["#132448", "#C4CED3"],
    "Tampa Bay Rays": ["#092C5C", "#8FBCE6"],
    "Toronto Blue Jays": ["#134A8E", "#E8291C"],
    // AL Central
    "Chicago White Sox": ["#27251F", "#C4CED3"],
    "Cleveland Guardians": ["#0C2340", "#E31937"],
    "Detroit Tigers": ["#0C2340", "#FA4616"],
    "Kansas City Royals": ["#004687", "#BD9B60"],
    "Minnesota Twins": ["#002B5C", "#D31145"],
    // AL West
    "Houston Astros": ["#002D62", "#EB6E1F"],
    "Los Angeles Angels": ["#BA0021", "#003263"],
    "Athletics": ["#003831", "#EFB21E"],
    "Oakland Athletics": ["#003831", "#EFB21E"],
    "Seattle Mariners": ["#0C2C56", "#005C5C"],
    "Texas Rangers": ["#003278", "#C0111F"],
    // NL East
    "Atlanta Braves": ["#CE1141", "#13274F"],
    "Miami Marlins": ["#00A3E0", "#EF3340"],
    "New York Mets": ["#002D72", "#FF5910"],
    "Philadelphia Phillies": ["#E81828", "#002D72"],
    "Washington Nationals": ["#AB0003", "#14225A"],
    // NL Central
    "Chicago Cubs": ["#0E3386", "#CC3433"],
    "Cincinnati Reds": ["#C6011F", "#000000"],
    "Milwaukee Brewers": ["#12284B", "#FFC52F"],
    "Pittsburgh Pirates": ["#FDB827", "#27251F"],
    "St. Louis Cardinals": ["#C41E3A", "#0C2340"],
    // NL West
    "Arizona Diamondbacks": ["#A71930", "#000000"],
    "Colorado Rockies": ["#333366", "#C4CED4"],
    "Los Angeles Dodgers": ["#005A9C", "#FFFFFF"],
    "San Diego Padres": ["#2F241D", "#FFC425"],
    "San Francisco Giants": ["#FD5A1E", "#27251F"],
};

function hashColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) % 360;
    }
    return `hsl(${hash}, 55%, 38%)`;
}

// Returns [primary, secondary] — real brand pair when known, otherwise
// a deterministic single-hue fallback so unmapped names still render.
export function mlbTeamColorPair(name) {
    return MLB_TEAM_COLORS[name] || [hashColor(name), hashColor(name)];
}
